"use client";

const title = 'Prescribing Information | CRENESSITY® (crinecerfont) HCP';
const description = 'Please see full Prescribing and Safety Information';

export const meta = {
  title,
  /* footer: {
     code: <>CP-CFT-US-0360</>,
     codeDate: <></>,
  }, */
  metadata: [
    {
      name: 'description',
      content: description,
    }, {
      name: 'twitter:title',
      content: title,
    }, {
      name: 'twitter:description',
      content: description,
    }, {
      property: 'og:title',
      content: title,
    }, {
      property: 'og:description',
      content: description,
    }, {
      property: 'og:url',
      content: 'https://www.crenessityhcp.com/view-pi',
    }, {
      property: 'og:site_name',
      content: 'CRENESSITY® (crinecerfont) HCP Website'
    }, {
      property: 'og:type',
      content: 'website',
    }, {
      property: 'og:image',
      content: 'https://www.crenessityhcp.com/images/og/MOA_Hero-Image.png',
    }, {
      name: 'robots',
      content: 'noindex, nofollow',
    }
  ],
  link: [
    {
      rel: 'canonical',
      href: 'https://www.crenessityhcp.com/view-pi',
    }, {
      rel: 'alternate',
      hrefLang: 'en-us',
      href: 'https://www.crenessityhcp.com/view-pi',
    },
  ],
  /* schemaTag: [
    
  ] */
};